import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SelectQuestion from 'sharedComponents/Quiz/components/SelectQuestion';
import InputQuestion from 'sharedComponents/Quiz/components/InputQuestion';
import SavingsQuestion from 'sharedComponents/Quiz/components/SavingsQuestion';
import AnnualIncomeQuestion from 'sharedComponents/Quiz/components/AnnualIncomeQuestion';
import SavingsMinimumQuestion from 'sharedComponents/Quiz/components/SavingsMinimumQuestion';
import MortgagePaymentQuestion from 'sharedComponents/Quiz/components/MortgagePaymentQuestion';
import MortgageBalanceQuestion from 'sharedComponents/Quiz/components/MortgageBalanceQuestion';
import IntermediateResults from 'sharedComponents/Quiz/components/IntermediateResults';
import QuizQuestionPresenter from 'presenters/QuizQuestionPresenter';
import QuizPresenter from 'presenters/QuizPresenter';

import { Box, Button } from '@material-ui/core';

import useStyles from './useStyles';

const QUESTION_TYPE_MAPPER = {
  selectQuestion: SelectQuestion,
  inputQuestion: InputQuestion,
  mortgageBalanceQuestion: MortgageBalanceQuestion,
  savingsQuestion: SavingsQuestion,
  mortgagePaymentQuestion: MortgagePaymentQuestion,
  annualIncomeQuestion: AnnualIncomeQuestion,
  savingsMinimumQuestion: SavingsMinimumQuestion,
};

const MobileQuiz = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    currentQuestion,
    quizValues,
    onNext,
    onChange,
    isCurrentQuestionValid,
    setCurrentQuestionValidity,
    manuallyChangedFields,
    setManuallyChangedField,
    calculatedValues,
    onPrevious,
    hasPreviousQuestion,
    isLastQuestion,
    onFinish,
  } = props;

  const type = QuizQuestionPresenter.type(currentQuestion);
  const QuestionComponent = QUESTION_TYPE_MAPPER[type];
  const { mortgagePaymentFinal, houseValue, houseValueDp } = calculatedValues;

  return (
    <Box className={classes.paper}>
      <Box className={classes.results}>
        <IntermediateResults
          mortgagePayment={mortgagePaymentFinal}
          houseValueDp={houseValueDp}
          houseValue={houseValue}
        />
      </Box>
      <Box className={classes.quizContainer}>
        <Box mt={3}>
          <QuestionComponent
            question={currentQuestion}
            values={quizValues}
            onChange={onChange}
            setValidity={setCurrentQuestionValidity}
            manuallyChangedFields={manuallyChangedFields}
            setManuallyChangedField={setManuallyChangedField}
          />
        </Box>
      </Box>
      <Box className={classes.controlBar}>
        {hasPreviousQuestion ? (
          <Button
            color="secondary"
            onClick={onPrevious}
            disabled={!hasPreviousQuestion}
            className={classes.controlButton}
          >
            {t('components.Quiz.MobileQuiz.previous')}
          </Button>
        ) : (
          <div />
        )}
        {isLastQuestion ? (
          <Button onClick={onFinish} disabled={!isCurrentQuestionValid} className={classes.controlButton}>
            {t('components.Quiz.MobileQuiz.finish')}
          </Button>
        ) : (
          <Button onClick={onNext} disabled={!isCurrentQuestionValid} className={classes.controlButton}>
            {t('components.Quiz.MobileQuiz.next')}
          </Button>
        )}
      </Box>
    </Box>
  );
};

MobileQuiz.propTypes = {
  currentQuestion: QuizQuestionPresenter.shape().isRequired,
  quizValues: QuizPresenter.shape().isRequired,
  onNext: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isCurrentQuestionValid: PropTypes.bool.isRequired,
  setCurrentQuestionValidity: PropTypes.func.isRequired,
  manuallyChangedFields: PropTypes.shape().isRequired,
  setManuallyChangedField: PropTypes.func.isRequired,
  calculatedValues: PropTypes.shape().isRequired,
  onPrevious: PropTypes.func.isRequired,
  hasPreviousQuestion: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
  isLastQuestion: PropTypes.bool.isRequired,
};

export default MobileQuiz;



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/MobileQuiz/MobileQuiz.js